module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921044149_T.9ec2d8ae.jpg";